import React, { useMemo } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import { map } from "lodash";
import NotFound from "@/pages/NotFound/NotFound";
import Dashbord from "./dashbord";

const loadableProps = {
  timeout: 60 * 1000,
};
const Loading = () => null;

const UserDetail = Loadable({
  ...loadableProps,
  loader: () =>
    import("../User/UserDetail" /* webpackChunkName:'UserDetail' */),
  loading: Loading,
});

const UserEdit = Loadable({
  ...loadableProps,
  loader: () => import("../User/UserEdit" /* webpackChunkName:'UserEdit' */),
  loading: Loading,
});

const TemplateAdd = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Template/TemplateAdd" /* webpackChunkName:'TemplateAdd' */),
  loading: Loading,
});

const RiskTemplateAdd = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      "../Template/RiskTemplateAdd" /* webpackChunkName:'RiskTemplateAdd' */
    ),
  loading: Loading,
});

const PackageAdd = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      "../PackageManagement/PackageAdd" /* webpackChunkName:'PackageAdd' */
    ),
  loading: Loading,
});

const RouterList = ($$) => {
  const renderRouterList = () => {
    const renderRouteList = (menuList) => {
      return map(menuList, (M) => {
        if (M.type === 1 && M.subMenu.length === 0 && M.path && M.component) {
          return (
            <Route exact path={M.path} key={M.id}>
              {M.component ? (
                <M.component
                  userId={$$.userId}
                  userName={$$.userName}
                  globalHistory={$$.history}
                  authInfo={M.authInfo}
                  permissions={M.permissions}
                />
              ) : null}
            </Route>
          );
        }

        return renderRouteList(M.subMenu);
      });
    };

    return (
      <Switch>
        {/* <Redirect  from="/" to="/dashbord" /> */}
        <Route exact path="/" component={Dashbord} />
        {renderRouteList($$.menuList)}

        <Route exact path="/user/detail/:id" component={UserDetail} />
        <Route exact path="/user/edit/:id" component={UserEdit} />
        <Route exact path="/template/add/:id?" component={TemplateAdd} />
        <Route
          exact
          path="/riskTemplate/add/:id?"
          component={RiskTemplateAdd}
        />
        <Route exact path="/package/add/:id?" component={PackageAdd} />

        <Route component={NotFound} />
      </Switch>
    );
  };

  const routerItems = useMemo(renderRouterList, [$$.length]);

  return routerItems;
};

export default RouterList;
